

const getKE = (kompList, komponenten) => {
    // console.log('kompList:', kompList);
    const KEList = kompList.map((item, i) => {
        const komp = komponenten.filter(f => f.ID === item.ID)[0]
        // console.log('komp', komp)
        return komp ? { KE: komp.BE, KCAL: komp.KCAL } : { KE: 0, KCAL: 0 };
    })
    const KESumme = KEList.reduce((prev, curr) => prev + curr.KE, 0);
    const KCALSumme = KEList.reduce((prev, curr) => prev + curr.KCAL, 0);
    // console.log('KEListe', KEList)
    return { KE: KESumme > 0 ? KESumme : '', KCAL: KCALSumme > 0 ? KCALSumme : '' }
}

export default getKE;